import React, { useEffect, useState } from "react";
import "./creditrefund.scss";
import Navbar from "../landing/header/Navbar";
import Buy from "./Buy";
import Refundtables from "./Refundtables";
import { useWeb3React } from "@web3-react/core";
import { requestWithState } from "../../@api/requestWithState";
import Loader from "../../hooks/loader";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import GetBalance from "../../hooks/refund_contract_call/getBalance";
import Environment from "../../utils/Environment";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";



const Creditrefund = () => {
  const { t } = useTranslation();
  const [purchases, setPurchases] = useState([]);
  const [loader, setLoader] = useState(false);
  const [claimLoader, setClaimLoader] = useState(false)
  const { account } = useWeb3React();
  const [country, setCountry] = useState("");
  const [purchaseLoader, setPurchaseLoader] = useState(false);
  const [balance, setBalance] = useState(0);
  const [isPremium, setIsPremium] = useState(null);
  const history = useHistory()
  const [refundTransactions, setRefundTransactions] = useState([]);
  const [expiryInfo, setExpiryInfo] = useState(null);
  const [creditPurchases, setCreditPurchases] = useState([]);
  const { GetBal } = GetBalance()
  const [whiteList, setWhiteList] = useState(false)
  const [show_Nav, setShow_Nav] = useState(false);
  const modalTwitter = localStorage?.getItem("twitter");
  const [show5, setShow5] = useState(false);

  const [earlyAccessModal, setEarlyAccessModal] = useState(false)

  const [earlyAccessModal2, setEarlyAccessModal2] = useState(false)
  const [email, setEmail] = useState("");


  const [verified, setVerified] = useState(false)
  useEffect(() => {
    localStorage.removeItem('fallback')
    const init = async () => {
      // localStorage.removeItem('twitter')

      console.log(localStorage.getItem("walletAddress"), "Wallet Address")
      if (!account && !localStorage.getItem("walletAddress")) {
        setPurchases([]);
        setLoader(false);
        setClaimLoader(false);
        setCountry("");
        setPurchaseLoader(false);
        setBalance(0);
        setIsPremium(null);
        setRefundTransactions([]);
        setExpiryInfo(null);
        setCreditPurchases([]);
        localStorage.removeItem("earlyAccessModal")

        // history.push('/');
        return;

      }

      setLoader(true);
      try {
        localStorage.setItem("walletAddress", account.toLowerCase()) // Store wallet address in local storage
        const premiumStatus = await checkIsPremium();
        // if (!localStorage?.getItem("twitter")) {
        //   handleShow5();
        // }
        await Promise.all([
          fetchPurchases(),
          getBalance(),
          get_ApiKeys(),
          fetchRefundTransactions(),
          fetchExpiryInfo(),
          fetchCreditPurchases(),
          // Optional: start showing loader
        ]);


      } catch (error) {
        console.error("Initialization error:", error);
      } finally {
        setLoader(false); // always hide loader
      }
    };

    init();
  }, [account]);

  useEffect(() => {
    if (!localStorage.getItem('twitter')) {
      handleShow5();
    }
  }, [])


  useEffect(() => {

    if (country && account) {
      checkVerification()
    }
  }, [country, account])

  const checkVerification = async () => {
    try {
      const response = await requestWithState({
        url: `/emails/wallet-details`,
        method: "POST",
        data: {
          country: country,
          by: account.toLowerCase()
        },
      });

      console.log(response, "Verification Response")
      if (response?.deta?.isVerified) {
        setVerified(true);
        console.log("Verified fetched successfully:", response?.deta);
        setEmail(response?.deta?.email)
        
      } else {
        setVerified(false);
        console.log("User is not verfied");
      }
    } catch (error) {
      setVerified(false);
      console.error("Error checking premium:", error);
    }
  };


  const handleClose5 = () => {
    setShow5(false);
    localStorage.setItem("twitter", true);
  };
  const handleShow5 = () => setShow5(true);

  const twitterHandler = () => {
    const weChatShareUrl = "https://x.com/Gems_VIP_";

    // Open the WeChat share link in a new window
    window.open(weChatShareUrl, "_blank");
    handleClose5();
  };





  // useEffect(() => {

  // }, []);



  const fetchGemsBalance = async () => {
    const balance = await GetBal(Environment.GEMS)
    if (balance < 30000) {
      console.log("EARLY ACCESS")
      setEarlyAccessModal2(false)
      // return false
    } else {
      setEarlyAccessModal2(false)
      // return true
    }

  }
  const get_ApiKeys = async () => {
    await requestWithState({
      url: "/me.json",
      method: "GET",
      customBaseURL: "https://ip.nf", // override baseURL
      onStart: () => console.log("Fetching IP..."),
      onSuccess: (response) => {
        const ip = response?.ip?.ip;
        get_ApiKeys1(ip);
        console.log("IP fetched:", ip);
      },
      onError: (error) => {
        console.error("Error fetching IP:", error);
      },
      onFinally: () => {
        console.log("IP fetch complete");
      },
    });
  };


  const get_ApiKeys1 = async (ip) => {
    await requestWithState({
      url: `/?ip=${ip}`,
      method: "GET",
      customBaseURL: "https://api.iplocation.net", // override baseURL
      onStart: () => console.log("Fetching country info..."),
      onSuccess: (response) => {
        const country = response?.country_name?.toLowerCase();
        setCountry(country);
        console.log("Country fetched:", country);
      },
      onError: (error) => {
        console.error("Error fetching country:", error);
        setCountry("india"); // default fallback
      },
      onFinally: () => {
        console.log("Country fetch complete");
      },
    });
  };

  const signCredit = async (sign, walletAddress, privateSale, token) => {
    return new Promise(async (resolve, reject) => {
      await requestWithState({
        url: '/credit/sign',
        method: 'POST',
        data: {
          walletAddress: walletAddress.toLowerCase(),
          privateSale: privateSale,
          tokenRefunded: Number(token),
          sign: sign
        },
        onStart: () => { },

        onSuccess: (response) => {
          console.log("Sign successful:", response?.data);
          resolve(response?.data); // ✅ return the data
        },
        onError: (error) => {
          console.log("Claim error:", error);
          toast.error("An error occurred while claiming the refund.");
          reject(error); // ❌ if there's an error
        },
        onFinally: () => {
          console.log("Sign process completed.");
        },
      });
    });
  };


  const checkIsPremium = async () => {
    try {
      const response = await requestWithState({
        url: `/credit/ispremium`,
        method: "POST",
        data: { walletAddress: account.toLowerCase() },
      });

      if (response?.data?.isPremiumUser) {
        setIsPremium(true);
        console.log("Premium fetched successfully:", response?.data);
        return true;
      } else {
        setIsPremium(false);
        console.log("User is not premium");
        return false;
      }
    } catch (error) {
      setIsPremium(false);
      console.error("Error checking premium:", error);
      return false;
    }
  };

  const claimRefund = async (pvtSale, tokenRefunded, sign, email) => {
    try {
      await requestWithState({
        url: '/credit/claim-refund',
        method: 'POST',
        data: {
          walletAddress: account.toLowerCase(),
          privateSale: pvtSale,
          tokenRefunded: Number(tokenRefunded),
          sign: sign,
          email: email,
          country: country
        },
        onStart: () => setClaimLoader(true),
        onSuccess: (response) => {
          console.log("Claim successful:", response);
          setClaimLoader(false);
          // fetchPurchases()
          // setShow5(true)
        },
        onError: (error) => {

          console.error("Claim error:", error);
          setClaimLoader(true);
          toast.error(error.message);
          setShow5(false)

        },
      })
    }

    catch (e) {
      console.log(e)
    }




  }



  const getBalance = () => {
    requestWithState({
      url: `/credit/credit/balance/?by=${account.toLowerCase()}`,
      method: "GET",
      data: null,
      // onStart: () => setLoader(true),
      onSuccess: (response) => {
        console.log("Balance fetched successfully:", response?.data);
        setBalance(response?.data?.remainingCredit);
      },
      onError: (error) => {
        console.error("Error fetching balance:", error);
      },
      // onFinally: () => setLoader(false),
    });

  }

  const fetchPurchases = async () => {
    const whitelistData = [];
    const transactionData = [];
    const fallbackPreviouslyUsed = localStorage.getItem("fallback") === 'true';

    // Fetch whitelist purchases
    await requestWithState({
      url: `/credit/whiltelist/eligible/?by=${account.toLowerCase()}`,
      method: "GET",
      data: null,
      onSuccess: (response) => {
        const result = response?.data;
        if (result?.length > 0) {
          whitelistData.push(...result);
          console.log("Whitelist purchases fetched:", result);
        } else {
          console.log("No whitelist data.");
        }
      },
      onError: (error) => {
        console.error("Error fetching whitelist purchases:", error);
      }
    });

    // Always fetch transaction purchases as well
    await requestWithState({
      url: `/credit/trasnaction/eligible/${account.toLowerCase()}`,
      method: "GET",
      data: null,
      onSuccess: (response) => {
        const result = response?.data?.data;
        if (result?.length > 0) {
          transactionData.push(...result);
          console.log("Transaction purchases fetched:", result);
        }
        localStorage.setItem("fallback", 'true'); // Mark fallback used
      },
      onError: (error) => {
        console.error("Error fetching transaction purchases:", error);
      }
    });

    // Merge data and update state
    const combinedData = [...whitelistData, ...transactionData];
    setPurchases(combinedData);
    setWhiteList(whitelistData.length > 0); // optionally show whether whitelist was involved
  };


  const navigator = () => {
    history.push('/premium')
  }

  const fetchRefundTransactions = async () => {
    await requestWithState({
      url: `/credit/refund/transaction/${account.toLowerCase()}`,
      method: "GET",
      onSuccess: (response) => {
        setRefundTransactions(response?.data);
        console.log("Refund transactions:", response?.data);
      },
      onError: (error) => {
        console.error("Error fetching refund transactions:", error);
      },
    });
  };

  const fetchExpiryInfo = async () => {
    await requestWithState({
      url: `/credit/expiry/${account.toLowerCase()}`,
      method: "GET",
      onSuccess: (response) => {
        setExpiryInfo(response?.data);
        console.log("Expiry info:", response?.data);
      },
      onError: (error) => {
        console.error("Error fetching expiry info:", error);
      },
    });
  };

  const fetchCreditPurchases = async () => {
    await requestWithState({
      url: `/credit/purchases/${account.toLowerCase()}`,
      method: "GET",
      onSuccess: (response) => {
        setCreditPurchases(response?.data);
        console.log("Credit purchases:", response?.data);
      },
      onError: (error) => {
        console.error("Error fetching credit purchases:", error);
      },
    });
  };


  if (loader) {
    return <Loader />;
  }



  return (
    <>
      <Navbar show_Nav={show_Nav} setShow_Nav={setShow_Nav} />
      <section className="creditrefundmain">
        {window.innerWidth < 600 && (
          <>
            <img
              src="/assets/creditrefund/topbglightmbl.png"
              alt="topbglight"
              className="topbglightmbl d-none show-in-light-theme"
            />
            <img
              src="/assets/creditrefund/topbgdarkmbl.png"
              alt="topbglight"
              className="topbgdarkmbl hide-in-light-theme"
            />
          </>
        )}
        <div className="custom-container">
          <div className="credittop">
            <img
              src="/assets/creditrefund/topbglight.png"
              alt="topbglight"
              className="topbglight d-none show-in-light-theme"
            />
            <img
              src="/assets/creditrefund/topbgdark.png"
              alt="topbglight"
              className="topbgdark hide-in-light-theme"
            />

            <div className="topleft">
              <h1 className="credithead">
                {t('Credit')} <span className="changefont"> {t('Refund')}</span>
              </h1>
              <p className="creditpara" style={{ maxWidth: "500px" }}>
                {t('Cre1')}
              </p>
              <p className="availablepara">{t('Cre2')}</p>
              <h6 className="availablehead">{balance ? balance?.toFixed(6) : 0}</h6>
              <p className="eachpara">{t('Cre3')}</p>
            </div>
            {!isPremium ? <div className="topright">
              <img
                src="/assets/creditrefund/rightbg.png"
                alt="rightbg"
                className="rightbg"
              />
              <h4 className="premiumhead">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                >
                  <path
                    d="M17.121 2.89008H4.50556L1.80225 8.2967L10.8133 19.1099L19.8243 8.2967L17.121 2.89008ZM8.66866 7.39559L10.0203 4.69228H11.6063L12.9579 7.39559H8.66866ZM9.91218 9.1978V15.2172L4.90204 9.1978H9.91218ZM11.7144 9.1978H16.7245L11.7144 15.2172V9.1978ZM17.3553 7.39559H14.9674L13.6157 4.69228H16.0036L17.3553 7.39559ZM5.62293 4.69228H8.01085L6.6592 7.39559H4.27127L5.62293 4.69228Z"
                    fill="#E89735"
                  />
                </svg>
                {t('GemsPremium')}
              </h4>
              <p className="premiumpara text-start">
                {t('Cre4')}
              </p>


              <button className="getbtn" onClick={navigator}>{t('Cre5')}</button>
            </div> : null}
          </div>
        </div>
      </section>
      <Refundtables
        data={purchases}
        claimRefund={claimRefund}
        claimLoader={claimLoader}
        setClaimLoader={setClaimLoader}
        signCredit={signCredit}
        account={account}
        fetchPurchases={fetchPurchases}
        isPremium={isPremium}
        navigator={navigator}
        country={country}
        getBalance={getBalance}
        refundTransactions={refundTransactions}
        expiryInfo={expiryInfo}
        creditPurchases={creditPurchases}
        fetchRefundTransactions={fetchRefundTransactions}
        fetchExpiryInfo={fetchExpiryInfo}
        fetchCreditPurchases={fetchCreditPurchases}
        earlyAccessModal={earlyAccessModal}
        setEarlyAccessModal={setEarlyAccessModal}
        earlyAccessModal2={earlyAccessModal2}
        setEarlyAccessModal2={setEarlyAccessModal2}
        whiteList={whiteList}
        setShow_Nav={setShow_Nav}
        setShow5={setShow5}
        email={email}
        setEmail={setEmail}
        verified={verified}
        setVerified={setVerified}
      />
      <Buy balance={balance} getBalance={getBalance} navigator={navigator} isPremium={isPremium} fetchCreditPurchases={fetchCreditPurchases} country={country} setShow5={setShow5} verified={verified} setVerified={setVerified} />
      {/* {isPremium &&<Refundtables data={purchases} claimRefund={claimRefund} claimLoader={claimLoader} />} */}
      <Modal
        className="common-modal-style followusonx-modal"
        show={show5}
        onHide={handleClose5}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('pre35')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="buydopnft-modal buynft-modal2">
            <img src="\assets\staking\followx.svg" alt="img" className="img-fluid d-none show-in-light-theme" />
            <img src="\assets\staking\followx-dark.svg" alt="img" className="img-fluid hide-in-light-theme" />
            <h4>{t('pre36')}</h4>
            <p className="newdeisgnpara">
              {t('pre37')}{" "}
            </p>
          </div>
          <div className="twice-btnsss">
            <button
              onClick={twitterHandler}
              className="btn-green sscscscscscsc"
            >
              {t('pre36')}
            </button>
          </div>
        </Modal.Body>
      </Modal>






    </>
  );
};

export default Creditrefund;